import {
	ActionsMenuSchemaProvider,
	ActionsProvider,
	BreakPointProvider,
	ContextMenuSchemaProvider,
	KeyboardShortcutsSchemaProvider,
	MenuSchemaProvider,
	ToolbarSchemaProvider,
	ToolsProvider,
	TranslationProvider,
} from '../hooks'
import { DialogsProvider } from '../hooks/useDialogsProvider'
import { HelpMenuSchemaProvider } from '../hooks/useHelpMenuSchema'
import { ToastsProvider } from '../hooks/useToastsProvider'
import { TldrawUiOverrides, useMergedOverrides, useMergedTranslationOverrides } from '../overrides'

/** @public */
export interface TldrawUiContextProviderProps {
	overrides?: TldrawUiOverrides | TldrawUiOverrides[]
	children?: any
}

/** @public */
export function TldrawUiContextProvider({ overrides, children }: TldrawUiContextProviderProps) {
	return (
		<TranslationProvider overrides={useMergedTranslationOverrides(overrides)}>
			<ToastsProvider>
				<DialogsProvider>
					<BreakPointProvider>
						<InternalProviders overrides={overrides}>{children}</InternalProviders>
					</BreakPointProvider>
				</DialogsProvider>
			</ToastsProvider>
		</TranslationProvider>
	)
}
function InternalProviders({ overrides, children }: TldrawUiContextProviderProps) {
	const mergedOverrides = useMergedOverrides(overrides)
	return (
		<ActionsProvider overrides={mergedOverrides.actions}>
			<ToolsProvider overrides={mergedOverrides.tools}>
				<ToolbarSchemaProvider overrides={mergedOverrides.toolbar}>
					<ActionsMenuSchemaProvider overrides={mergedOverrides.actionsMenu}>
						<KeyboardShortcutsSchemaProvider overrides={mergedOverrides.keyboardShortcutsMenu}>
							<ContextMenuSchemaProvider overrides={mergedOverrides.contextMenu}>
								<HelpMenuSchemaProvider overrides={mergedOverrides.helpMenu}>
									<MenuSchemaProvider overrides={mergedOverrides.menu}>
										{children}
									</MenuSchemaProvider>
								</HelpMenuSchemaProvider>
							</ContextMenuSchemaProvider>
						</KeyboardShortcutsSchemaProvider>
					</ActionsMenuSchemaProvider>
				</ToolbarSchemaProvider>
			</ToolsProvider>
		</ActionsProvider>
	)
}
